module.exports = __webpack_public_path__ + "static/media/excelFrame.bc5bf16b.svg";